import { LOCAL_STORAGE_KEYS } from '@app/dashboard/constants/local-storage-keys';
import { FEE_RATE, MODAL_STEP_STATUS, } from '@app/dashboard/constants/Bills';
import { getFromLocalStorage } from '@app/dashboard/utils/manageLocalStorage';
import { formatAmountWithCommas } from '@unified-checkout/design-system';

export const isDistributor = () => {
  return getFromLocalStorage(LOCAL_STORAGE_KEYS.IS_DISTRIBUTOR);
}

export const isStatusVisible = (currentStatus: string) => {
  return ([
    MODAL_STEP_STATUS.SUCCESS,
    MODAL_STEP_STATUS.FAILED,
    MODAL_STEP_STATUS.PENDING,
  ] as string[]).includes(currentStatus);
};

export const validateField = (field: any, value: string) => {
  if (!field?.validation?.regex) return undefined;

  const regex = new RegExp(field.validation.regex);

  return regex.test(value)
    ? undefined
    : field.validation.message;
};

export const calcRemainingBalance = (amount: number, totalBalance: number) => {
  const feeAmount = amount * FEE_RATE;
  const totalAmount = totalBalance - (amount + feeAmount);
  const formatAmount = formatAmountWithCommas({ amount: totalAmount });
  
  return formatAmount;
}
